import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  buildingList: [],
  uniqueFYEDate:[],
  uniqueBuildingAccManager:[],
};

const BuildingSlice = createSlice({
  name: "BuildingSlice",
  initialState,
  reducers: {
    setBuildingList: (state, action) => {
      state.buildingList = action.payload;
    },
    setUniqueBuildingAccManager: (state, action) => {
      state.uniqueBuildingAccManager = action.payload;
    },
    setUniqueFYEDate: (state, action) => {
      state.uniqueFYEDate = action.payload;
    },
  },
});
export const {
  setBuildingList,
  setUniqueFYEDate,
  setUniqueBuildingAccManager

} = BuildingSlice.actions;

export default BuildingSlice.reducer;
